export const dspFeatures = ['chroma', 'chord', 'rms', 'tuner', 'fft'] as const
export type DSPFeatureName = (typeof dspFeatures)[number]
// @note we also dispatch a 'all' feature that has all the features
export type DSPAllFeatureName = 'all'

export type DSPFeatureNameWithAll = DSPFeatureName | DSPAllFeatureName
